import { Skeleton } from '~/shared/ui/SkeletonList'

export function LoadingBlock() {
  return (
    <>
      <Skeleton animated $height={63} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={21} style={{ marginBottom: '20px' }} />

      <Skeleton animated $height={587} />
    </>
  )
}
